import Link from "next/link";
import Player from "@/components/LottiePlayer";


export default function Grid() {
  return (
    <section className="flex flex-col items-center justify-center font-['Inter'] px-8 sm:px-0 mx-auto xl:max-w-7xl lg:max-w-5xl md:max-w-3xl w-ful rounded-md" >
      <div className="flex flex-col justify-center items-center text-center py-8" tabIndex={0}>
        <h3 className="w-full medium-title text-center font-['Inter']">
        Ready to transform your organization&lsquo;s data capabilities? 
        </h3>
        <p className="body-text max-w-xl mt-4">
        Explore our cutting-edge solutions designed to empower your organization&apos;s data journey and drive data-driven success. 
        </p>
      </div>
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl w-full mt-16 mb-8 grid grid-cols-1 md:grid-cols-2 gap-8 px-4">
        <div className="border border-2 md:col-span-2 shadow-md rounded-2xl flex flex-col justify-end hover:shadow-2xl hover:cursor-pointer">
          <Link href="/solutions/ai-data-services">
            <div className="m-10 flex flex-col items-start">
            <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/artificial-intelligence.json"
                  style={{ height: "50px", width: "50px" }}
                />
                </div>
              <h5 className="text-2xl pt-3">AI Data Services</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-full  body-text">
              Turn your scattered business data into answers you can act on — in 5 days.
              </h5>
            </div>
          </Link>
        </div>
        <div className="border border-2 md:row-span-2 shadow-md rounded-2xl flex flex-col justify-end hover:shadow-2xl hover:cursor-pointer hover:cursor-pointer">
          <Link href="/solutions/open-data-portals">
            <div className="m-10 flex flex-col items-start">
            <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/data-portal.json"
                  style={{ height: "50px", width: "50px" }}
                />
                </div>
              <h5 className="text-2xl pt-3">
                Open Data Portals
              </h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20">
              </div>
              <h5 className="pt-3 max-w-full  body-text">
              Compliance. Transparency. Innovation. Whatever your reason for publishing data to the world, you want a data portal.
              </h5>
            </div>
          </Link>
  </div>
        <div className="border border-2 shadow-md rounded-2xl hover:shadow-2xl hover:cursor-pointer">
          <Link href="/solutions/data-catalogs">
            <div className="m-10 flex flex-col items-start">
              <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/data-catalog.json"
                  style={{ height: "50px", width: "50px" }}
                />
                </div>
              <h5 className="text-2xl pt-3">Data Catalogs</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-full  body-text">
                A single point of data discovery. Because you can’t use what you can’t find.
              </h5>
            </div>
          </Link>
        </div>
        <div className="border border-2 shadow-md rounded-2xl hover:shadow-2xl hover:cursor-pointer">
          <Link href="/solutions/ckan">
            <div className="m-10 flex flex-col items-start">
              <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/boat.json"
                  style={{ height: "50px", width: "50px", color: "orange" }}
                />
                </div>
              <h5 className="text-2xl pt-3">CKAN</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-full  body-text">
               Whether you are looking to publish data openly or manage internal data, CKAN lets you build systems that scale.
              </h5>
            </div>
          </Link>
        </div>
        <div className="border border-2 md:col-span-2 shadow-md rounded-2xl flex flex-col justify-end hover:shadow-2xl hover:cursor-pointer">
          <Link href="/solutions/internal-data-management">
            <div className="m-10 flex flex-col items-start">
            <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/folders.json"
                  style={{ height: "50px", width: "50px" }}
                />
                </div>
              <h5 className="text-2xl pt-3">Internal Data Management</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-full  body-text">
               A data management system helps your teams locate, store, secure, share, and version your data. Your data needs, sorted.
              </h5>
            </div>
          </Link>
        </div>
        <div className="border border-2 shadow-md rounded-2xl hover:shadow-2xl hover:cursor-pointer">
          <Link href="/solutions/data-engineering">
            <div className="m-10 flex flex-col items-start">
            <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/api.json"
                  style={{ height: "50px", width: "50px" }}
                />
                </div>
              <h5 className="text-2xl pt-3">Data Engineering</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-full  body-text">
               Whether your data is big or small, we design and build graceful systems that help your data flow.
              </h5>
            </div>
          </Link>
        </div>
        <div className="border-2 shadow-md rounded-2xl hover:shadow-2xl hover:cursor-pointer">
          <Link href="/solutions/data-strategy">
            <div className="m-10 flex flex-col items-start">
              <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/presentation-4.json"
                  style={{ height: "50px", width: "50px" }}
                />
                </div>
              <h5 className="text-2xl pt-3">Data Strategy</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-full  body-text">
               We’ve been building data solutions for almost 20 years. Consider your legal, social, and technical needs covered.
              </h5>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
